export function windowRefFactory(): any {
  return window;
}

export function windowRefServerFactory(): any {
  return undefined;
}
